<script setup>
import {reactive} from 'vue'
import api from '@/services/api'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    tableName: String,
    id: Number
})

const itemDataStore = useItemDataStore()

// --- Reactive State ---
const state = reactive({
    tags: [],
    tagStr: ''
})

// --- Methods ---
const setTags = async () => {
    const obj = await api.get(`api/tags/tag-ids/${props.tableName}/${props.id}`)
    const tagIds = obj.data.tagIds

    state.tags = await itemDataStore.preload({
        tableName: 'tags',
        ids: tagIds,
    })
}

const saveTag = async (tag) => {
    const obj = await api.post('api/tags/save-tag', {
        tableName: props.tableName,
        itemId: props.id,
        tag: tag,
    })

    const item = obj.data.item
    state.tags.push(item)
    state.tagStr = ''
}

const createTag = () => {
    const str = state.tagStr

    if (/,/.test(str)) {
        const array = str.split(',')
        array.forEach((subStr) => {
            if (subStr.length) {
                saveTag(subStr.trim())
            }
        })
    } else {
        saveTag(str)
    }
}

const removeTag = async (i) => {
    const tag = state.tags[i]
    state.tags.splice(i, 1)
    await api.post('api/tags/remove-tag-from-item', {
        tableName: props.tableName,
        itemId: props.id,
        tagId: tag.id,
    })
}

// --- Initialization ---
setTags()
</script>

<template>
    <div>
        <form class="mb-3" @submit.prevent="createTag">
            <div>
                <input v-model="state.tagStr" class="form-control" ng-select type="text">

                <button class="btn btn-light" type="submit">
                    <i class="bi-plus-lg"/>
                </button>
            </div>
        </form>

        <div class="d-flex align-items-center">
            <span v-for="(tag, index) in state.tags" :key="tag.id"
                  class="me-2 bg-dark text-light border rounded p-1 ps-2 d-flex align-items-center">
                {{ tag.tag }}
                <button aria-label="Close" class="btn-close btn-close-white ms-1" type="button"
                        @click="removeTag(index)"></button>
            </span>
        </div>
    </div>
</template>